// Bloques comunes de subtemas por tema y categoría (consultas, pedidos, reclamos)

const subtemasLeasingConsultas = {
  "80420441190": { label: "Consultas sobre leasing" }
};

const subtemasLeasingPedidos = {
  "70120441146": { label: "Cuadro de marcha préstamo" },
  "7012044729": { label: "Envío de comprobantes" },
  "7012044937": { label: "Envío de documentación" },
  "7012044936": { label: "Envío de notas" },
  "70120441213": { label: "Opción de compra" },
  "70120441218": { label: "Precancelación" },
  "70120441065": { label: "Seguros" }
};

const subtemasLeasingReclamos = {
  "80220441148": { label: "Demora de trámite" },
  "80220441065": { label: "Seguros" }
};

const temasLeasing = {
  consultas: { label: "Leasing", subtema: subtemasLeasingConsultas },
  pedidos: { label: "Leasing", subtema: subtemasLeasingPedidos },
  reclamos: { label: "Leasing", subtema: subtemasLeasingReclamos }
};

// ------------------

const subtemasTarjetasConsultas = {
  "804546401": { label: "Comisiones" },
  "804546752": { label: "Pago de tarjeta" },
  "804546938": { label: "Consulta y capacitación tarjeta recargable" },
  "8045461114": { label: "Consulta ABM tarjetas" },
  "8045461120": { label: "Consulta del limite y/o disponible" },
  "8045461154": { label: "Detalle de movimientos" }
};

const subtemasTarjetasReclamos = {
  "802546743": { label: "No puede efectuar compra" },
  "802546746": { label: "Impuesto mal cobrado" },
  "8025461097": { label: "Bonificación no efectuada" },
  "8025461103": { label: "Comisión mal cobrada" },
  "8025461162": { label: "Error en ABM de Tarjetas" }
};

const temasTarjetas = {
  consultas: { label: "Tarjetas", subtema: subtemasTarjetasConsultas },
  reclamos: { label: "Tarjetas", subtema: subtemasTarjetasReclamos }
};

// ------------------

const subtemasTransferenciasConsultas = {
  "804547693": { label: "Motivo de rechazo" },
  "8045471115": { label: "Consulta como obtener comprobantes" },
  "8045471188": { label: "Estado" }
};

const subtemasTransferenciasPedidos = {
  "7015471092": { label: "Anulacion operación" }
};

const subtemasTransferenciasReclamos = {
  "8025471214": { label: "Operación duplicada" },
  "8025471230": { label: "Transferencia no acreditada" }
};

const temasTransferencias = {
  consultas: {
    label: "Transferencias",
    subtema: subtemasTransferenciasConsultas
  },
  pedidos: { label: "Transferencias", subtema: subtemasTransferenciasPedidos },
  reclamos: { label: "Transferencias", subtema: subtemasTransferenciasReclamos }
};

// ------------------

const temasLatampass = {
  consultas: {
    label: "LATAMPASS",
    subtema: {
      "8045791088": { label: "Acerca del programa (c/e)" }
    }
  },
  pedidos: {
    label: "LATAMPASS",
    subtema: {
      "701579718": { label: "Modificación de mail LATAMPASS" }
    }
  },
  reclamos: {
    label: "LATAMPASS",
    subtema: {
      "8025791090": { label: "Reclamos LATAMPASS" }
    }
  }
};

// ------------------

const temasFraude = {
  consultas: {
    label: "Fraude",
    subtema: {
      "804980982": { label: "Consulta posible fraude" }
    }
  },
  reclamos: {
    label: "Fraude",
    subtema: {
      "802980704": { label: "Net Cash" }
    }
  }
};

const temasDebitosAutomaticos = {
  consultas: {
    label: "Debitos automaticos",
    subtema: {
      "804577675": { label: "Alta baja modificación o reversa DA" },
      "804577678": { label: "Stop debit" }
    }
  },
  pedidos: {
    label: "Débitos automáticos",
    subtema: {
      "701577675": { label: "Alta baja modificación o reversa DA" },
      "701577678": { label: "Stop debit" }
    }
  }
};

// ------------------

const subtemasComprobantesConsultas = {
  "804100101146": { label: "Cuadro de marcha préstamo" },
  "804100101147": { label: "Cuota debitada préstamo" },
  "804100101200": { label: "Liquidación de acuerdo" },
  "804100101223": { label: "Retención de ganancias en plazo fijo" }
};

const subtemasComprobantesPedidos = {
  "701100101146": { label: "Cuadro de marcha préstamo" },
  "701100101147": { label: "Cuota debitada préstamo" },
  "70110010715": { label: "Detalle de acuerdo" },
  "701100101194": { label: "Fondo común de inversión" },
  "70110010717": { label: "Fondo de desempleo" },
  "701100101197": { label: "Impuesto a las gcias en plazo fijo" },
  "70110010673": { label: "Recaudaciones" },
  "701100101224": { label: "Reversa deb automático" }
};

const temasComprobantes = {
  consultas: { label: "Comprobantes", subtema: subtemasComprobantesConsultas },
  pedidos: { label: "Comprobantes", subtema: subtemasComprobantesPedidos }
};

// ------------------

const subtemasChequesConsultas = {
  "80410011709": { label: "Boleta de depósito" },
  "80410011694": { label: "Cesión de cheques" },
  "804100111105": { label: "Como dar de alta autorizado" },
  "804100111108": { label: "Como pedir chequera" },
  "804100111110": { label: "Como visualizar cheques" },
  "804100111199": { label: "Información de estado de cheques" },
  "80410011693": { label: "Motivo de rechazo" }
};

const subtemasChequesPedidos = {
  "70110011941": { label: "Anulación de rechazo BCRA" },
  "70110011709": { label: "Boleta de depósito" },
  "70110011694": { label: "Cesión de cheques" },
  "70110011711": { label: "Imagen" },
  "70110011712": { label: "Valores en custodia" }
};

const subtemasChequesReclamos = {
  "802100111160": { label: "Error en alta de autorizado" },
  "802100111169": { label: "Error en débito o crédito" },
  "802100111178": { label: "Error en imagen de cheque" },
  "802100111207": { label: "No aparece cheque" }
};

const temasCheques = {
  consultas: { label: "Cheques", subtema: subtemasChequesConsultas },
  pedidos: { label: "Cheques", subtema: subtemasChequesPedidos },
  reclamos: { label: "Cheques", subtema: subtemasChequesReclamos }
};

// ------------------
// Otros temas consultados, pedidos y reclamos, similares pero más específicos, extraídos igual:

const temasAcuerdos = {
  consultas: {
    label: "Acuerdos",
    subtema: {
      "80410031680": { label: "Consulta" }
    }
  },
  reclamos: {
    label: "Acuerdos",
    subtema: {
      "802100311209": { label: "No puede generar acuerdo" }
    }
  }
};

const temasAdministracionControl = {
  consultas: {
    label: "Administración y control",
    subtema: {
      "804100321124": { label: "Consulta sobre ABM de usuarios" }
    }
  },
  reclamos: {
    label: "Administración y control",
    subtema: {
      "802100321165": { label: "Error en configuración de usuario" },
      "802100321187": {
        label: "Error en validación de configuración de usuario"
      }
    }
  }
};

const temasCuentas = {
  consultas: {
    label: "Cuentas",
    subtema: {
      "804100351104": { label: "Consulta sobre cuentas" },
      "804100351111": { label: "Consulta sobre movimientos" },
      "804100351113": { label: "Detalle transferencias enviadas" },
      "80410035609": { label: "Detalle transferencias recibidas" }
    }
  },
  reclamos: {
    label: "Cuentas",
    subtema: {
      "802100351180": { label: "Error en movimientos de dias anteriores" },
      "802100351217": { label: "Error en posición financiera" },
      "802100351212": { label: "No ve cuenta" },
      "802100351225": { label: "Saldo erroneo" }
    }
  }
};

const temasDebitosDirectos = {
  consultas: {
    label: "Debitos directos",
    subtema: {
      "804100371101": { label: "Capacitación" },
      "804100371130": { label: "Consulta sobre archivo" }
    }
  },
  pedidos: {
    label: "Debitos directos",
    subtema: {
      "701100371092": { label: "Anulación operación" }
    }
  },
  reclamos: {
    label: "Debitos directos",
    subtema: {
      "80210037739": { label: "Error en acreditación" },
      "802100371192": { label: "Falta devolución" }
    }
  }
};

const temasEcheq = {
  consultas: {
    label: "Echeq",
    subtema: {
      "804100381121": { label: "Consulta mensaje de error" },
      "804100381087": { label: "Consultas de operatoria" }
    }
  },
  reclamos: {
    label: "Echeq",
    subtema: {
      "802100381157": { label: "Error en aceptación" },
      "802100381168": { label: "Error en custodia/rescate" },
      "802100381170": { label: "Error en depósito" },
      "802100381172": { label: "Error en descuento o negociación" },
      "802100381173": { label: "Error en emisión" },
      "802100381174": { label: "Error en endoso" },
      "802100381181": { label: "Error en pedido de devolución" }
    }
  }
};

const temasEresumen = {
  consultas: {
    label: "Eresumen",
    subtema: {
      "804100391107": { label: "Como descaragar resumenes" }
    }
  },
  pedidos: {
    label: "Eresumen",
    subtema: {
      "701100391191": { label: "Extractos más antiguos" }
    }
  },
  reclamos: {
    label: "Eresumen",
    subtema: {
      "802100391211": { label: "No se pudo generar extracto" }
    }
  }
};

const temasInversiones = {
  consultas: {
    label: "Inversiones",
    subtema: {
      "804100431143": { label: "Derivación a la mesa de dinero" },
      "804100431122": { label: "Navegación por net cash" }
    }
  },
  reclamos: {
    label: "Inversiones",
    subtema: {
      "802100431161": { label: "Error en alta de Cuenta Custodia" },
      "802100431186": { label: "Error en suscripción o rescate de FCI" }
    }
  }
};

const temasPaginas = {
  consultas: {
    label: "Pagina",
    subtema: {
      "804100461145": { label: "Consulta de codigos de servicios" },
      "804100461215": { label: "Operatoria gral" }
    }
  },
  reclamos: {
    label: "Página",
    subtema: {
      "802100461098": { label: "Caída general de la página" }
    }
  }
};

const temasProveedores = {
  consultas: {
    label: "Proveedores",
    subtema: {
      "804100471101": { label: "Capacitación" },
      "804100471112": { label: "Consulta alta baja modificación de proveedor" },
      "804100471115": { label: "Consulta reporte pagos" }
    }
  },
  pedidos: {
    label: "Proveedores",
    subtema: {
      "701100471092": { label: "Anulación operación" }
    }
  },
  reclamos: {
    label: "Proveedores",
    subtema: {
      "802100471192": { label: "Falta devolución" }
    }
  }
};

const temasComercios = {
  consultas: {
    label: "Atención a comercios",
    subtema: {
      "8041005199997": { label: "ABM comercios" },
      "8041005199998": { label: "Cupones (creditos o debitos)" },
      "804100512030": { label: "Pago inmediato de cupones" },
      "8041005199996": { label: "Portal de marcas" },
      "804100511032": { label: "Promoción" },
      "80410051201": { label: "Puntos BBVA" },
      "8041005199999": { label: "Reclamos Prisma" }
    }
  },
  pedidos: {
    label: "Atención a comercios",
    subtema: {
      "7011005199997": { label: "ABM comercios" },
      "70110051939": { label: "Baja de terminal" },
      "70110051625": { label: "Liquidaciones" },
      "70110051813": { label: "Promociones" },
      "7011005199999": { label: "Reclamos Prisma" }
    }
  },
  reclamos: {
    label: "Atención a comercios",
    subtema: {
      "80210051949": { label: "Comisiones mal cobradas" },
      "8021005199998": { label: "Cupones (creditos o debitos)" },
      "80210051813": { label: "Promociones" },
      "80210051201": { label: "Puntos BBVA" },
      "8021005199999": { label: "Reclamos Prisma" }
    }
  }
};

const temasServiciosAdicionales = {
  consultas: {
    label: "Servicios adicionales",
    subtema: {
      "804100481126": { label: "Consulta sobre avisos y mensajes" },
      "804100481129": { label: "Consulta sobre descarga de archivos" },
      "804100481132": { label: "Consulta sobre envío de documentación" }
    }
  },
  reclamos: {
    label: "Servicios adicionales",
    subtema: {
      "802100481171": { label: "Error en descarga de archivos" },
      "802100481176": { label: "Error en envío de documentación" }
    }
  }
};

const temasSueldos = {
  consultas: {
    label: "Sueldos",
    subtema: {
      "804100501141": { label: "Consulta sobre motivos de rechazo" },
      "804100501125": { label: "Consultas y capacitación" }
    }
  },
  pedidos: {
    label: "Sueldos",
    subtema: {
      "701100501092": { label: "Anulación operación" }
    }
  },
  reclamos: {
    label: "Sueldos",
    subtema: {
      "80210050739": { label: "Error en acreditación" },
      "802100501163": { label: "Error en apertura de cuenta empleado" },
      "802100501184": { label: "Error en procesamiento de pago o archivo" },
      "802100501192": { label: "Falta devolución" }
    }
  }
};

const temasServiciosImpuestos = {
  consultas: {
    label: "Servicios e impuestos",
    subtema: {
      "804100491115": { label: "Consulta como obtener comprobantes" },
      "804100491116": { label: "Consulta de empresa de servicios" }
    }
  },
  reclamos: {
    label: "Servicios e impuestos",
    subtema: {
      "802100491177": { label: "Error en firma de pago" },
      "802100491179": { label: "Error en la generación del comprobante" },
      "802100491210": { label: "No se debitó el pago" }
    }
  }
};

export default {
  googleAnalyticsId: null,
  modulo: "Contacto Empresas",
  combos: {
    ayuda: {
      "804": {
        label: "Consultas",
        tema: {
          "804544": {
            label: "Recaudaciones",
            subtema: {
              "8045441128": {
                label: "Consulta sobre depósito"
              },
              "8045441134": {
                label: "Consulta sobre estado de depositante"
              },
              "8045441142": {
                label: "Consulta sobre parametrización del convenio"
              }
            },
            "804546": temasTarjetas.consultas,
            "804547": temasTransferencias.consultas,
            "804577": temasDebitosAutomaticos.consultas,
            "804579": temasLatampass.consultas,
            "804980": temasFraude.consultas,
            "8041100": {
              label: "Id erróneo",
              subtema: {
                "80411001158": {
                  label: "Error en identificación"
                }
              }
            },
            "8042044": temasLeasing.consultas,
            "804100101": temasComprobantes.consultas,
            "804100117": temasCheques.consultas,
            "804100316": temasAcuerdos.consultas,
            "804100321": temasAdministracionControl.consultas,
            "80410034": {
              label: "Comex",
              subtema: {
                "804100341144": {
                  label: "Consulta sobre configuración de permisos y servicios"
                },
                "804100341226": {
                  label:
                    "Se deriva a la mesa de ayuda comex por consulta específica"
                }
              }
            },
            "804100351": temasCuentas.consultas,
            "804100371": temasDebitosDirectos.consultas,
            "804100381": temasEcheq.consultas,
            "804100391": temasEresumen.consultas,
            "80410040": {
              label: "Facturas electronicas",
              subtema: {
                "804100401101": {
                  label: "Capacitación"
                }
              }
            },
            "80410041": {
              label: "Gestion de claves/ token",
              subtema: {
                "804100411095": {
                  label: "Blanqueo o desbloqueo clave de acceso"
                },
                "804100411096": {
                  label: "Blanqueo o desbloqueo clave de firma"
                },
                "804100411153": {
                  label: "Desbloqueo o sincronización de token"
                }
              }
            },
            "80410042": {
              label: "Gestión de tramites",
              subtema: {
                "804100421101": {
                  label: "Capacitación"
                }
              }
            },
            "804100431": temasInversiones.consultas,
            "80410046": temasPaginas.consultas,
            "804100471": temasProveedores.consultas,
            "80410048": temasServiciosAdicionales.consultas,
            "80410049": temasServiciosImpuestos.consultas,
            "80410050": temasSueldos.consultas,
            "80410051": temasComercios.consultas,
            "80410055": {
              label: "Derivación a otros sectores",
              subtema: {
                "80410055705": {
                  label: "Derivación a otro sector"
                }
              }
            },
            "80410059": {
              label: "Información general",
              subtema: {
                "80410059401": {
                  label: "Comisiones"
                },
                "804100591025": {
                  label: "Estado de embargo"
                }
              }
            }
          }
        },
        "9000": {
          label: "Openpay",
          tema: {
            "90009000": {
              label: "Derivacion Openpay",
              subtema: {
                "90009000900006": {
                  label: "Reclamos e incidencias Openpay"
                },
                "90009000900005": {
                  label: "Solicitudes Openpay"
                }
              }
            },
            "90009001": {
              label: "Consulta Openpay",
              subtema: {
                "9000900190001": {
                  label: "App mpos link QR"
                },
                "90009001900003": {
                  label: "Cuenta digital"
                },
                "90009001900004": {
                  label: "Dashboard"
                },
                "90009001900002": {
                  label: "Tarjeta prepaga"
                }
              }
            }
          }
        },
        "701": {
          label: "Pedidos",
          tema: {
            "701547": temasTransferencias.pedidos,
            "701577": temasDebitosAutomaticos.pedidos,
            "701579": temasLatampass.pedidos,
            "7012044": temasLeasing.pedidos,
            "701100101": temasComprobantes.pedidos,
            "701100119": temasCheques.pedidos,
            "701100371": temasDebitosDirectos.pedidos,
            "701100391": temasEresumen.pedidos,
            "70110047": temasProveedores.pedidos,
            "70110050": temasSueldos.pedidos,
            "70110051": temasComercios.pedidos
          }
        },
        "802": {
          label: "Reclamos",
          tema: {
            "802546": temasTarjetas.reclamos,
            "802547": temasTransferencias.reclamos,
            "802579": temasLatampass.reclamos,
            "802901": {
              label: "Impuestos",
              subtema: {
                "802901746": {
                  label: "Impuesto mal cobrado"
                },
                "802901947": {
                  label: "Impuesto no informado en AFIP"
                }
              }
            },
            "802902": {
              label: "Comisiones",
              subtema: {
                "802902949": {
                  label: "Comisiones mal cobradas"
                }
              }
            },
            "802980": temasFraude.reclamos,
            "8022044": temasLeasing.reclamos,
            "802100111": temasCheques.reclamos,
            "802100311": temasAcuerdos.reclamos,
            "802100321": temasAdministracionControl.reclamos,
            "802100351": temasCuentas.reclamos,
            "80210036": {
              label: "Debin",
              subtema: {
                "802100361185": {
                  label: "Error en salto a plataforma Debin"
                }
              }
            },
            "802100377": temasDebitosDirectos.reclamos,
            "802100381": temasEcheq.reclamos,
            "802100391": temasEresumen.reclamos,
            "802100431": temasInversiones.reclamos,
            "80210044": {
              label: "Operaciones",
              subtema: {
                "802100441166": {
                  label: "Error en consulta de ficheros"
                },
                "802100441175": {
                  label: "Error en envío de archivos"
                }
              }
            },
            "80210046": temasPaginas.reclamos,
            "8025471213": temasProveedores.reclamos,
            "80210048": temasServiciosAdicionales.reclamos,
            "80210049": temasServiciosImpuestos.reclamos,
            "80210050": temasSueldos.reclamos,
            "80210051": temasComercios.reclamos,
            "80210058": {
              label: "Inconveniente de sistemas",
              subtema: {
                "80210058704": {
                  label: "Net Cash"
                }
              }
            }
          }
        }
      }
    }
  }
};
